module.exports = __webpack_public_path__ + "img/banner-back.766d3bda.png";